export default __webpack_public_path__ + "static/media/icon-arrow-right.0d717dd8.svg";